import * as actionTypes from "./TripsType";

const INITIAL_STATE = {
    tripList: [],
    tripData: null,
    cityList: [],
    countryList: [],
    airportList: [],
    seatPreferenceList: [],
    mealPreferenceList: [],
    flightPreferenceList: [],
    carTypeList: [],
    busPreferenceList: [],
    busSeatPreferenceList: [],
    attachmentList: [],
    basicFilterData: [],
    tripPolicy: {},
    approvalStatus: []
};

const TripReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETTRIPLIST:
            return {
                ...state,
                tripList: action.payload.list,
            };
        case actionTypes.SETTRIPDATA:
            return {
                ...state,
                tripData: action.payload.list,
            };
        case actionTypes.SETCITYLIST:
            return {
                ...state,
                cityList: action.payload.list,
            };
        case actionTypes.SETCOUNTRYLIST:
            return {
                ...state,
                countryList: action.payload.list,
            };
        case actionTypes.SETAIRPORTLIST:
            return {
                ...state,
                airportList: action.payload.list,
            };
        case actionTypes.SETSEATPREFERENCE:
            return {
                ...state,
                seatPreferenceList: action.payload.list,
            };
        case actionTypes.SETMEALPREFERENCE:
            return {
                ...state,
                mealPreferenceList: action.payload.list,
            };
        case actionTypes.SETFLIGHTPREFERENCE:
            return {
                ...state,
                flightPreferenceList: action.payload.list,
            };
        case actionTypes.SETCARTYPELIST:
            return {
                ...state,
                carTypeList: action.payload.list,
            };
        case actionTypes.SETBUSPREFERENCE:
            return {
                ...state,
                busPreferenceList: action.payload.list,
            };
        case actionTypes.SETBUSSEATPREFERENCE:
            return {
                ...state,
                busSeatPreferenceList: action.payload.list,
            };
        case actionTypes.SETATTACHMENTLIST:
            return {
                ...state,
                attachmentList: action.payload.list,
            };
        case actionTypes.SETTRIPBASICFILTERDATA:
            return {
                ...state,
                basicFilterData: { ...action.payload }
            };
        case actionTypes.SETTRIPPOLICY:
            return {
                ...state,
                tripPolicy: action.payload.list,
            };
        case actionTypes.SETAPPROVALSTATUS:
            return {
                ...state,
                approvalStatus: action.payload.list,
            };
        case actionTypes.CLEARDOC:
            return {
                ...state,
                tripData: null,
                attachmentList: []
            };
        default:
            return state;
    }
};

export default TripReducer;